var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.onlyRenderIfCancelable || _vm.state.cancelable)?_c('button',{staticClass:"vue-fine-uploader-cancel-button",attrs:{"type":"button","aria-label":"cancel","disabled":!_vm.state.cancelable},on:{"click":_vm._onClick}},[_vm._t("default",[_vm._v("Cancel")])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61baedfb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-fineuploader/cancel-button.vue
// module id = r1t+
// module chunks = 0